import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { MainComponent } from './main/main.component';
import { ChatComponent } from './chat/chat.component';
import {ChatRoutingModule} from './chat-routing.module';
import { InputComponent } from './input/input.component';
import {MatButtonModule, MatDialogModule, MatIconModule, MatInputModule, MatRadioModule} from '@angular/material';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {InputModule} from '../input/input.module';
import { ProfileQuizComponent } from './profile-quiz/profile-quiz.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { BlocksComponent } from './blocks/blocks.component';
import { QuizComponent } from './quiz/quiz.component';
import { ProfileComponent } from './profile/profile.component';
import { ProfileAboutComponent } from './profile/profile-about/profile-about.component';
import {LoginComponent} from './login/login.component';
import {SharedModule} from '../shared/shared.module';
import {AuthGuard} from '../auth/_guards/auth.guard';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import {SlickCarouselModule} from "ngx-slick-carousel";
import { GuestUserComponent } from './guest-user/guest-user.component';
import { OtherInputComponent } from './other-input/other-input.component';
import { AljDeniedComponent } from './alj-denied/alj-denied.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import {MatSelectModule} from '@angular/material/select';




@NgModule({
  declarations: [
      HeaderComponent,
      MainComponent,
      ChatComponent,
      InputComponent,
      ProfileQuizComponent,
      DashboardComponent,
      QuizComponent,
      ProfileComponent,
      ProfileAboutComponent,
      LoginComponent,
      BlocksComponent,
      GuestUserComponent,
      OtherInputComponent,
      AljDeniedComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ChatRoutingModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatRadioModule,
    MatDialogModule,
    InputModule,
    SharedModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatSelectModule,
    NgxMaskModule.forRoot(),
    SlickCarouselModule
  ],
    entryComponents: [
            ChatComponent,
    ]
})
export class ChatQuizModule { }
